import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import Portal from "components/atoms/Portal"
import H from "components/atoms/H"
import useWindowSize from "utils/useWindowSize"

import {
  StyledSpotlightWrapper,
  StyledProjectWrapper,
  StyledLocationIconRect,
  StyledLocationIcon,
  StyledHeadingWrapper,
  StyledAddressWrapper,
  StyledPOI,
} from "./Spotlight.styles"

const Spotlight = ({
  markerLocation,
  projectName,
  projectAddress,
  mapContainerRef,
  handleHideSpotlight,
  showSpotlight,
  isBannerActive,
}) => {
  const [mapContainer, setMapContainer] = useState(null)
  const [markerLoc, setMarkerLoc] = useState(null)
  const size = useWindowSize()

  const iconSize = 24 // in pixels

  const {
    leftTabColumnAddressLine1,
    leftTabColumnAddressLine2,
    leftTabColumnAddressLine3,
  } = projectAddress || {}

  useEffect(() => {
    if (mapContainerRef && mapContainerRef.current) {
      setMapContainer(mapContainerRef.current.getBoundingClientRect())
    }
  }, [size.width, size.height])

  useEffect(() => {
    if (markerLocation) {
      setMarkerLoc(markerLocation)
    }
  }, [markerLocation])

  useEffect(() => {
    if (showSpotlight) {
      document.body.style.overflow = "hidden"
    }
    // eslint-disable-next-line no-return-assign
    return () => (document.body.style.overflow = "unset")
  }, [])

  const getMarkerPosition = () => ({
    x: mapContainer.width / 2 + markerLoc.x - iconSize / 2,
    y: mapContainer.height / 2 + markerLoc.y - iconSize / 2,
  })

  return (
    <Portal id="spotlight">
      {markerLoc ? (
        <StyledSpotlightWrapper>
          <StyledProjectWrapper onMouseOver={handleHideSpotlight}>
            <StyledHeadingWrapper isBannerActive={isBannerActive}>
              <H as="h4">{projectName}</H>
              {projectAddress && (
                <StyledAddressWrapper>
                  <StyledLocationIcon isActive>
                    <StyledLocationIconRect />
                  </StyledLocationIcon>
                  {`${leftTabColumnAddressLine1}${
                    leftTabColumnAddressLine2
                      ? `, ${leftTabColumnAddressLine2}`
                      : ""
                  }${
                    leftTabColumnAddressLine3
                      ? `, ${leftTabColumnAddressLine3}`
                      : ""
                  }`}
                </StyledAddressWrapper>
              )}
            </StyledHeadingWrapper>
          </StyledProjectWrapper>
          {mapContainer && (
            <>
              {markerLoc && (
                <>
                  <StyledPOI
                    left={mapContainer.x + getMarkerPosition().x}
                    top={mapContainer.y + getMarkerPosition().y}
                    iconSize={iconSize}
                  />
                </>
              )}
            </>
          )}
        </StyledSpotlightWrapper>
      ) : (
        ""
      )}
    </Portal>
  )
}

Spotlight.propTypes = {
  markerLocation: PropTypes.shape(),
  projectName: PropTypes.string.isRequired,
  projectAddress: PropTypes.shape().isRequired,
  mapContainerRef: PropTypes.shape().isRequired,
  handleHideSpotlight: PropTypes.func.isRequired,
  showSpotlight: PropTypes.bool.isRequired,
  isBannerActive: PropTypes.bool.isRequired,
}

Spotlight.defaultProps = {
  markerLocation: null,
}

export default Spotlight
